import symbolBlackUrl from "@/assets/logos/symbol-black.svg"
import symbolWhiteUrl from "@/assets/logos/symbol-white.svg"
import { cn } from "@/shared/lib/cn"

/**
 * Assinatura da marca: simbolo + "DIMPET" + descritor.
 *
 * As duas versoes (header claro e rodape escuro) eram componentes separados no
 * prototipo, com a mesma estrutura e tamanhos ligeiramente diferentes. Aqui a
 * diferenca e uma prop.
 */

export interface LogoProps {
  tone?: "dark" | "light"
  className?: string
}

const TONE = {
  dark: {
    src: symbolBlackUrl,
    gap: "gap-2.5",
    symbol: "h-10 w-10",
    wordmark: "text-[17px] text-verde-profundo",
    descriptor: "text-[7.5px] text-dourado-escuro mt-[3px]",
  },
  light: {
    src: symbolWhiteUrl,
    gap: "gap-3",
    symbol: "h-12 w-12",
    wordmark: "text-[18px] text-off-white",
    descriptor: "text-[7.5px] text-dourado-claro mt-[4px]",
  },
} as const

export function Logo({ tone = "dark", className }: LogoProps) {
  const style = TONE[tone]

  return (
    // role="img" + aria-label: o nome da marca esta partido em dois <span> por
    // causa do layout. Sem isto, um leitor de tela anuncia "DIMPET" e "SAUDE
    // PREVENTIVA" como dois fragmentos soltos.
    <div
      className={cn("flex items-center", style.gap, className)}
      role="img"
      aria-label="DIMPET Saúde Preventiva"
    >
      <img src={style.src} alt="" aria-hidden="true" className={cn("object-contain shrink-0", style.symbol)} />

      <div className="flex flex-col leading-none">
        <span className={cn("font-semibold tracking-[0.03em]", style.wordmark)}>DIMPET</span>
        <span className={cn("font-medium tracking-[0.2em] uppercase", style.descriptor)}>
          SAÚDE PREVENTIVA
        </span>
      </div>
    </div>
  )
}

/** So o simbolo, sem tipografia. Usado no topo do menu mobile. */
export function LogoSymbol({ className }: { className?: string }) {
  return <img src={symbolBlackUrl} alt="DIMPET" className={cn("h-8 w-8 object-contain", className)} />
}
